// extracted by mini-css-extract-plugin
module.exports = {"element":"alert-bar_element__OTlqH"};